export const COLOR_MAP_BOARDS: { [key: number]: string } = {
    1: "#000",
    2: "#000",
    7: "#000",
    8: "#000"
};